export const user = {
    state: {
        status: 'idle',
        user: null,
        userProfile: null
    },
    mutations: {
        SET_USER_STATUS(state, status) {
            state.status = status
        },
        SET_USER(state, user) {
            state.user = user
        },
        SET_USER_PROFILE(state, user) {
            state.userProfile = user
        }
    },
    actions: {
        async fetchUserProfile({ state, commit }) {
            const res = await this.$api.get('api/users/profile')
            await commit('SET_USER_PROFILE', res.data.data)
        },
        fetchUser({ commit }, userId) {
            commit('SET_USER', null)
            commit('SET_USER_STATUS', 'loading')
            return this.$api.get(`api/users/${userId}.json`).then(response => {
                commit('SET_USER', response.data.data)
                commit('SET_USER_STATUS', 'idle')
            }).catch(error => {
                commit('SET_USER_STATUS', 'error')
                return Promise.reject(error)
            })
        },
        addUser({ commit }, payload) {
            return new Promise((resolve, reject) => {
                commit('SET_USER_STATUS', 'saving')
                this.$api.post('api/users/add.json', payload).then(response => {
                    commit('SET_USER_STATUS', 'idle')
                    resolve()
                }).catch(error => {
                    commit('SET_USER_STATUS', 'error')
                    reject(error)
                })
            })
        }
    },
    getters: {
        userProfile: state => state.userProfile,
        userStatus: (state) => {
            return state.status
        },
        user: (state) => {
            if(state.user) {
                return state.user
            }
        }
    }
}
